<template>
  <div style="width: 100%">
    <highcarts :options="chartOptions" style="width: 100%" :Highcharts="$hc"></highcarts>
  </div>
</template>
<script>
  import {Chart} from 'highcharts-vue'
  import { Color } from '../../../utils/Color'

  export default {
    components: {
      'highcarts': Chart
    },
    props: {
      chartData: {
        type: Object,
        required: true,
        default: () => ({
          'actions': {},
          'categories': {},
        })
      }
    },
    mounted() {
      var dateFormat = Intl.DateTimeFormat('hu', {year: 'numeric', month: 'short'})
      var formatDate = (dateString) => dateFormat.format(Date.parse(dateString))

      this.chartOptions.xAxis.categories = _.map(this.chartData.categories, category => formatDate(category))

      var mapValues = (action) => {
        return _.map(this.chartData.categories, category => {
          if (typeof action[category] === 'undefined') {
            return null
          } else {
            return parseInt(action[category])
          }
        })
      }

      _.forEach(this.chartData.actions, (action, name) => {
        var data = mapValues(action)

        this.chartOptions.series.push({
          name: `Action ${name}`,
          data,
          color: Color.action(name).toString(),
        })
      })
    },
    data() {
      return {
        chartOptions: {
          chart: {
            type: 'streamgraph',
            zoomtype: 'xy',
            marginBottom: 150
          },
          title: undefined,
           yAxis: {
            visible: false,
            startOnTick: false,
            endOnTick: false
          },
          xAxis: {
            categories: [],
            type: 'category',
            maxPadding: 0,
            crosshair: true,
            labels: {
              align: 'left',
              reserveSpace: false,
              rotation: 270
            },
            lineWidth: 0,
            margin: 20,
            tickWidth: 0,
          },
          legend: {
            enabled: false,
          },

          plotOptions: {
            series: {
              label: {
                minFontSize: 5,
                maxFontSize: 15,
                style: {
                  color: 'rgba(255,255,255,0.75)'
                }
              }
            }
          },
          series: [],
        }
      }
    }
  }
</script>